// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"524":"e2d75866b7772054bdef","852":"d851c45af4aa62e2ee10"}[chunkId] + ".css";
};